module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAALJJREFUeNpiYBgFwx0wkqtRSlzaHo/0h2cvn17Ep5+FAkcfwCP3AIgVaWUxCCyAYgwfE9LINBTj+D++oAbG8WhQj/CgZqFyCF4A+vQjMQopjeMEaEECwwXEaqR2UF+gl8WgRHSQHI0Dlp1GLR68FgNLLH1ixGjh4wlAi+KRLJ0PpALoFdSwvFsALUToEscFSGWxALTQmECX2gkapwegbSsHYstnqgCQ5UDMP9pQH/QAIMAALNMz9FEouUAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/vent/7.png
// module id = 762
// module chunks = 0